import { EntityType } from '@frontend/common';
import React, { useEffect, useState } from 'react';

import SelectInputV2, { SelectInputV2Props } from '../select/select-input-v2/select-input-v2.component';

const ID = 'entity-type-select';

export interface EntityTypeSelectProps extends Omit<SelectInputV2Props<EntityType>, 'options'> {
    subset?: EntityType[] | (() => Promise<EntityType[]>);
}

export const EntityTypeSelect = (props: EntityTypeSelectProps) => {
    const [options, changeOptions] = useState<EntityType[]>(props.subset ? Object.values(EntityType) : Object.values(EntityType).slice(1));
    useEffect(() => {
        if (props.subset) {
            if (typeof props.subset === 'function') props.subset().then(changeOptions);
            else changeOptions(props.subset);
        }
    }, [props.subset]);

    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            className={props.className}
            options={mapEntityTypesToOptions(options)}
            value={props.value}
            label={props.label || 'Entity type'}
            required={props.required}
            onSelect={props.onSelect}
        />
    );
};

/** Display label for an entity type enum value (underscores → spaces). */
export function formatEntityTypeLabel(entityType: EntityType | string): string {
    if (entityType == EntityType.ALL) return 'All';
    if (entityType == EntityType.UNDEFINED) return '';
    const withSpaces = String(entityType).replace(/_/g, ' ');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

function mapEntityTypesToOptions(entityTypes: EntityType[]): { label: string; value: string }[] {
    return entityTypes.map((entityType) => ({
        value: entityType,
        label: formatEntityTypeLabel(entityType)
    }));
}
